const jsmGlobalSettingsPages = [
	'/jira/settings/products/jira-service-management-configuration',
	'/jira/settings/products/jira-service-management-email-requests',
	'/jira/settings/products/servicedesk/customer-access',
	'/jira/settings/products/servicedesk/authentication',
	'/jira/settings/products/servicedesk/organizations',
	'/jira/settings/products/jira-service-management-incident-management-tools',
	'/jira/settings/products/jira-service-management-compliance',
	'/jira/settings/products/servicedesk/feature-usage',
];

const eocGlobalSettingsPages = [
	'/jira/settings/products/ops/roles',
	'/jira/settings/products/ops/role-assignment',
	'/jira/settings/products/ops/role-based-notifications',
	'/jira/settings/products/ops/jira-service-management-chatops-and-video-tools',
	'/jira/settings/products/ops/integrations',
	'/jira/settings/products/ops/heartbeats',
	'/jira/settings/products/ops/syncs',
	'/jira/settings/products/ops/policies',
	'/jira/settings/products/ops/maintenance',
	'/jira/settings/products/ops/escalation-policies',
	'/jira/settings/products/ops/incoming-call',
	'/jira/settings/products/ops/jira-service-management-audit-logs',
	'/jira/settings/products/ops/reports',
];

const isJsmGlobalSettingsPage = (route: string) => jsmGlobalSettingsPages.includes(route);
const isEocGlobalSettingsPage = (route: string) => eocGlobalSettingsPages.includes(route);

export const isInJsmGlobalSettingsBoundary = (route: string): boolean =>
	isJsmGlobalSettingsPage(route) || isEocGlobalSettingsPage(route);
